import script from "./ArticleShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleShare.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleShare.vue?vue&type=style&index=0&id=5e58d108&lang=scss"

const __exports__ = script;

export default __exports__